import React, { useState } from "react";
import { getDeviceTypeByName, updateDeviceType } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import DeviceTypeNameField from "./DeviceTypeNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditDeviceTypeModal({ setShowModal, validationErrors, selectedDeviceType }) {

    const [deviceType, setDeviceType] = useState(selectedDeviceType);

    const onSaveClick = async () => {

        const serverDeviceType = await getDeviceTypeByName(deviceType.name);
        let savedDeviceType;

        if ((serverDeviceType.error && serverDeviceType.statusCode === 404) || serverDeviceType.id === deviceType.id) {
            savedDeviceType = await updateDeviceType(deviceType);
        } else {
            showDangerToast(`Device Type with name '${deviceType.name}' already exist`, "Save Device Type")
        }

        if (savedDeviceType) {
            showSuccessToast("Device Type updated", "Save Device Type");
            setShowModal(false);
        }

    }

    return (
        <TargetTypeWizardModal
            title="Edit Device Type Wizard"
            subtitle="Update the selected device type target."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <DeviceTypeNameField deviceType={deviceType} setDeviceType={setDeviceType} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditDeviceTypeModal);
